export type StageType = 'dev' | 'qa' | 'pre' | 'live'

let stageName: StageType = 'live'

/* istanbul ignore next if */
if (location.hostname.indexOf('auth-intermediate-qa.') !== -1) {
  stageName = 'qa'
} /* istanbul ignore next else */ else if (location.hostname.indexOf('auth-intermediate-pre.') !== -1) {
  stageName = 'pre'
} /* istanbul ignore next else */ else if (location.hostname === 'localhost') {
  stageName = 'dev'
}

export function getStage(): StageType {
  return stageName
}
